/* eslint-disable max-lines */
import { ImodelLimit, IsubscriptionPackage } from '@biz-nest/core-client';

export const subscriptionPackages: IsubscriptionPackage[] = [
  {
    name: 'Starter',
    amount: 10,
    duration: 1,
    features: [
      {
        type: 'user',
        name: 'Users',
        description: 'Contains Only 1 user account',
        limitSize: 1,
        remainingSize: 1
      },
      {
        type: 'document',
        name: 'Business Document',
        description: 'Contains Only 1 user account',
        limitSize: 15,
        remainingSize: 15
      },
      {
        type: 'item',
        name: 'Item',
        description: 'Unlimited items',
        limitSize: 10000000,
        remainingSize: 1000000,
        isUnlimited: true
      },
      {
        type: 'customer',
        name: 'Customers',
        description: 'Contains Only 1 user account',
        limitSize: 50,
        remainingSize: 50
      },
      {
        type: 'analytics',
        name: 'Analytics',
        description: 'Contains Only 1 user account',
        limitSize: 50000,
        remainingSize: 50000,
        isUnlimited: true
      },
      {
        type: 'helpTicket',
        name: '2 Support Tickets',
        description: 'Contains Only 1 user account',
        limitSize: 3,
        remainingSize: 3
      },
      {
        type: 'dataRecoveryWindow',
        name: 'Data Recovery Window',
        description: 'Contains Only 1 user account',
        limitSize: 7,
        remainingSize: 7
      }
    ]
  },
  {
    name: 'Standard',
    amount: 30,
    duration: 1,
    features: [
      {
        type: 'user',
        name: 'Users',
        description: 'Contains Only 1 user account',
        limitSize: 5,
        remainingSize: 5
      },
      {
        type: 'document',
        name: 'Document Quota',
        description: 'Contains Only 1 user account',
        limitSize: 100,
        remainingSize: 100
      },
      {
        type: 'item',
        name: 'Item',
        description: 'Unlimited items',
        limitSize: 10000000,
        remainingSize: 1000000,
        isUnlimited: true
      },
      {
        type: 'customer',
        name: 'Unlimitted Customers',
        description: 'Contains Only 1 user account',
        limitSize: 2000,
        remainingSize: 2000,
        isUnlimited: true
      },
      {
        type: 'analytics',
        name: 'Analytics',
        description: 'Contains Only 1 user account',
        limitSize: 100000,
        remainingSize: 100000,
        isUnlimited: true
      },
      {
        type: 'helpTicket',
        name: 'Unlimmited Support',
        description: 'Contains Only 1 user account',
        limitSize: 100,
        remainingSize: 100
      },
      {
        type: 'dataRecoveryWindow',
        name: 'Data Recovery Window',
        description: 'Contains Only 1 user account',
        limitSize: 30,
        remainingSize: 30
      },
      {
        type: 'mail',
        name: 'Email Accounts',
        description: 'Contains Only 1 user account',
        limitSize: 5,
        remainingSize: 5
      }
    ]
  },
  {
    name: 'Advanced',
    amount: 80,
    duration: 1,
    features: [
      {
        type: 'user',
        name: 'Users',
        description: 'Contains Only 1 user account',
        limitSize: 10,
        remainingSize: 10
      },
      {
        type: 'document',
        name: 'Document Quota',
        description: 'Contains Only 1 user account',
        limitSize: 500,
        remainingSize: 500
      },
      {
        type: 'item',
        name: 'Item',
        description: 'Unlimited items',
        limitSize: 10000000,
        remainingSize: 1000000,
        isUnlimited: true
      },
      {
        type: 'customer',
        name: 'Unlimitted Customers',
        description: 'Contains Only 1 user account',
        limitSize: 10000,
        remainingSize: 10000,
        isUnlimited: true
      },
      {
        type: 'analytics',
        name: 'Analytics',
        description: 'Contains Only 1 user account',
        limitSize: 5000,
        remainingSize: 5000,
        isUnlimited: true
      },

      /* {
        type: 'advancedAnalytics',
        name: 'Advanced Analytics',
        description: 'Contains Only 1 user account',
        limitSize: 5000,
        remainingSize: 5000,
        isUnlimited: true
      }, */
      {
        type: 'helpTicket',
        name: 'Unlimmited Support',
        description: 'Contains Only 1 user account',
        limitSize: 100,
        remainingSize: 100
      },
      {
        type: 'dataRecoveryWindow',
        name: 'Data Recovery Window',
        description: 'Contains Only 1 user account',
        limitSize: 90,
        remainingSize: 90
      },
      {
        type: 'mail',
        name: 'Email Accounts',
        description: 'Contains Only 1 user account',
        limitSize: 10,
        remainingSize: 10
      }
    ]
  },
  {
    name: 'Trial',
    amount: 0,
    duration: 1,
    features: [
      {
        type: 'user',
        name: 'Users',
        description: 'Contains Only 1 user account',
        limitSize: 1,
        remainingSize: 1
      },
      {
        type: 'document',
        name: 'Document Quota',
        description: 'Contains Only 1 user account',
        limitSize: 3,
        remainingSize: 3
      },
      {
        type: 'item',
        name: 'Item',
        description: 'Unlimited items',
        limitSize: 10,
        remainingSize: 10
      },
      {
        type: 'customer',
        name: 'Customers',
        description: 'Contains Only 1 user account',
        limitSize: 50,
        remainingSize: 50
      },
      {
        type: 'analytics',
        name: 'Analytics',
        description: 'Contains Only 1 user account',
        limitSize: 1000,
        remainingSize: 1000,
        isUnlimited: true
      }
    ]
  }
];

/*
Editable, allows customising the subscription package
*/
export const customiseUserQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 10,
    cost: 10 // in dollars, full
  },
  {
    val: 50,
    cost: 20
  },
  {
    val: 100,
    cost: 30
  }
];

export const customiseDocumentQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];


export const customiseItemQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];


export const customiseAnalyticsQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];

export const customiseAdvancedAnalyticsQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];

export const customiseHelpTicketQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];

export const customiseMailQuota: ImodelLimit[] = [
  {
    val: 0,
    cost: 0 // in dollars, full
  },
  {
    val: 100,
    cost: 5 // in dollars, full
  },
  {
    val: 200,
    cost: 10
  },
  {
    val: 300,
    cost: 15
  },
  {
    val: 500,
    cost: 25
  },
  {
    val: 1000,
    cost: 50
  },
  {
    val: 5000,
    cost: 250
  },
  {
    val: 10000,
    cost: 500
  }
];


